import React, { useEffect, useState } from "react";
import Space from "../ui/Space";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { ROUTES } from "../utils/Routes";
import VirtualTable from "../ui/VirtualTable";
import { KBD } from "../utils/Keybindings";
import Divider from "../ui/Divider";
import Float from "../ui/Float";
import { listen } from "../hooks/Listener";
import { kbdEvent } from "../utils/Utils";
import Nav from "../ui/Nav";
import HomeStations from "../components/HomeStations";
import { showError } from "../ui/Message";
import { apiCall } from "../utils/Api";
import Cookies from "js-cookie";
import ReleaseNotes from "../components/ReleaseNotes";


export default function HomeController(props) {

    const { signal = {}, controller = "home", setController = () => { } } = props;

    const logout = (_store_id = window.credentials.store_id) => {
        apiCall("account/logout", { store_id: _store_id }, (_s, _r) => {
            if (_s) {
                Cookies.set("workstation", null, { expires: 14 })
                window.history.replaceState(null, '', '/');
                window.location.reload();
            } else {
                showError(_r)
            }
        })
    }


    const menu = [
        { disabled: (window?.beta), key: KBD.Digit1, menu: "Orders", action: () => (window?.beta) ? "" : setController("orders") },
        { disabled: false, key: KBD.Digit2, menu: "Inventory", action: () => setController("inventory") },
        { disabled: (window?.beta), key: KBD.Digit3, menu: "Suppliers", action: () => (window?.beta) ? "" : setController("suppliers") },
        { disabled: (window?.beta), key: KBD.Digit4, menu: "Point-of-Sale", action: () => (window?.beta) ? "" : setController("pos") },
        { disabled: (window?.beta), key: KBD.Digit5, menu: "Returns" },
        { disabled: (window?.beta), key: KBD.Digit6, menu: "Customers", action: () => (window?.beta) ? "" : setController("customers") },
        { disabled: (window?.beta), key: KBD.Digit7, menu: "Accounts Payable" },
        { disabled: (window?.beta), key: KBD.Digit8, menu: "Order Processing", action: () => (window?.beta) ? "" : setController("processing") },
        { disabled: (window?.beta), key: KBD.Digit9, menu: "Test", action: () => (window?.beta) ? "" : setController("test") },
        { disabled: false, key: KBD.Digit0, menu: "Reports", action: () => setController("reports") },
        { disabled: (window?.beta), key: KBD.MINUS, menu: "TitleBank" },
        { disabled: (window?.beta), key: KBD.EQUAL, menu: "General Ledger" },
        { disabled: (window?.beta), key: KBD.D, menu: "Data Transfer" },
        { disabled: (window?.beta), key: KBD.M, menu: "Miscellaneous" },
        { disabled: (window?.beta), key: KBD.S, menu: "Scheduler" },
        { disabled: (window?.beta), key: KBD.W, menu: "Webstore" },
        { disabled: false, key: KBD.E, menu: "Exit Bookmanager", action: () => logout() },
    ]

    const stations = [
        { station: "69", name: "Mikey", status: "", date: "10:49am" },
        { station: "0", name: "", status: "", date: "10:49am" },
        { station: "24", name: "Tobias", status: "Not running", date: "Oct 7" },
        { station: "9", name: "Michael", status: "Not running", date: "Oct 7" },
        { station: "21", name: "Kenzie", status: "Not running", date: "Oct 7" },
        { station: "5", name: "", status: "Not running", date: "Oct 3" },
        { station: "23", name: "Madi", status: "Not running", date: "Sept25" },
        { station: "25", name: "", status: "Not running", date: "Sept 6" },
        { station: "16", name: "Trevor", status: "Not running", date: "Aug29" },
        { station: "99", name: "", status: "Not running", date: "Aug28" },
        { station: "28", name: "", status: "Not running", date: "Aug26" },
        { station: "26", name: "Diana", status: "Not running", date: "Aug22" },
        { station: "27", name: "Bingus", status: "Not running", date: "Aug21" },
        { station: "38", name: "April", status: "Not running", date: "Aug 6" },
        { station: "2", name: "", status: "Not running", date: "Jun25" },
        { station: "42", name: "", status: "Not running", date: "Jun 3" },
        { station: "8", name: "", status: "Not running", date: "Apr 5" },

    ]

    const tools = [
        { disabled: true, key: KBD.ALT_F9, tools: "Console" },
        { disabled: true, key: KBD.ALT_H, tools: "Remote Support" },
        { disabled: (window?.beta), key: KBD.ALT_S, tools: "Setup" },
        { disabled: true, key: KBD.F1, tools: "Help" },
        { disabled: false, key: KBD.F2, tools: "Stock search" },
        { disabled: true, key: KBD.F3, tools: "Messaging" },
        { disabled: false, key: KBD.F4, tools: "Classs / BISAC" },
        { disabled: true, key: KBD.F5, tools: "Repeat Data" },
        { disabled: false, key: KBD.F6, tools: "Log In / Out" },
        { disabled: true, key: KBD.F7, tools: "Calculator" },
        { disabled: true, key: KBD.MINUS, tools: "TitleBank" },
        { disabled: true, key: KBD.EQUAL, tools: "General Ledger" },
        { disabled: true, key: KBD.D, tools: "Data Transfer" },
        // { disabled: (window?.beta), key: KBD.M, tools: "Miscellaneous" },
        // { disabled: (window?.beta), key: KBD.S, tools: "Scheduler" },
        // { disabled: (window?.beta), key: KBD.W, tools: "Webstore" },
        // { disabled: (window?.beta), key: KBD.E, tools: "Exit Bookmanager" },
    ]


    const [state, setState] = useState({
        menu: {
            key: "menu",
            active: true,
            selected: menu[0],
            route: ROUTES.HOME.MENU
        },
        notes: {
            key: "notes",
            active: false,
            selected: {},
            route: ROUTES.HOME.NOTES
        },
        station: {
            key: "station",
            active: false,
            selected: stations[0],
            route: ROUTES.HOME.STATIONS
        }, tools: {
            key: "tools",
            active: false,
            selected: tools[0],
            route: ROUTES.HOME.TOOLS
        }
    });


    const setView = (_view) => {
        let _s = { ...state };
        if (_view === "menu") {
            _s.menu.active = true;
            _s.station.active = false;
            _s.tools.active = false;
            _s.notes.active = false;
            setState(_s);
        }

        if (_view === "notes") {
            _s.notes.active = true;
            _s.menu.active = false;
            _s.station.active = false;
            _s.tools.active = false;
            setState(_s);
        }

        if (_view === "station") {
            _s.menu.active = false;
            _s.station.active = true;
            _s.tools.active = false;
            _s.notes.active = false;
            setState(_s);
        }
        if (_view === "tools") {
            _s.menu.active = false;
            _s.station.active = false;
            _s.tools.active = true;
            _s.notes.active = false;
            setState(_s);
        }
    }


    const switchView = (_right = false) => {

        if (_right && state.menu.active) {
            setView("station");
            return;
        }

        if (_right && state.station.active) {
            setView("notes");
            return;
        }

        if (_right && state.notes.active) {
            setView("tools");
            return;
        }

        if (!_right && state.tools.active) {
            setView("notes");
            return;
        }

        if (!_right && state.notes.active) {
            setView("station");
            return;
        }

        if (!_right && state.station.active) {
            setView("menu");
            return;
        }
    };

    const station_nav = [
        { text: "Close" },
        { text: "Del" },
        { text: "Edit" },
    ]


    const runAction = (_e) => {

        if (_e.hasOwnProperty("action")) {
            _e.action();
        }

    }

    const actions = [
        { key: KBD.ARROW_LEFT, action: (e) => { switchView(false) } },
        { key: KBD.ARROW_RIGHT, action: (e) => { switchView(true) } },
        {
            key: KBD.ENTER, action: (e) => {
                if (state.menu.active) {
                    runAction(state.menu.selected)
                } else if (state.tools.active) {
                    setTimeout(() => {
                        kbdEvent(state.tools.selected?.key);
                    }, 50)

                }
            }
        },
    ];

    useEffect(() => {


        let _route = ROUTES.HOME.MENU;
        let _keys = actions.concat(menu);
        if (state.station.active) {
            _route = ROUTES.HOME.STATIONS;
            _keys = actions.concat(station_nav);
        }
        if (state.notes.active) {
            _route = ROUTES.HOME.NOTES;
            _keys = actions;
        }
        if (state.tools.active) {
            _route = ROUTES.HOME.TOOLS
            _keys = actions;
        }
        if (window.bm_state.value === ROUTES.HOME.TOOLS || window.bm_state.value === ROUTES.HOME.STATIONS || window.bm_state.value === ROUTES.HOME.MENU || window.bm_state.value === ROUTES.HOME.NOTES) {
            window.bm_state.value = _route;
        }

        const cleanup = listen(controller, _route, _keys, false, [], [], [], (e) => {
            alert(e)
        });
        return () => cleanup(); // Ensure cleanup on unmount
    }, [actions, state, menu]);


    const menu_columns = [
        {
            key: "menu", align: "left", title: <>Main Menu</>, width: 500, render: (e, f) => {

                return (
                    <div className={f.disabled ? "beta" : ""}>
                        <Space size={6}>
                            <div></div>
                            <div style={{ "width": "20px", "textAlign": "center" }}>{f.key.label}</div>
                            <div></div>
                            <Divider vertical />
                            <div></div>
                            <div>{e}</div>
                        </Space>
                    </div>
                )
            }
        },
    ]

    let station_columns = [
        { key: "station", align: "center", title: <div style={{ "position": "relative", "width": "635px", "textAlign": "left", "padding": "0px 10px" }}><Float>Active Stations (2)</Float></div>, width: 60, grow: true },
        { key: "name", align: "left", title: <></>, width: 251 },
        { key: "status", align: "left", title: <></>, width: 200 },
        { key: "date", align: "left", title: <><div style={{ "position": "relative", "width": "200px", "textAlign": "right", "padding": "0px 10px" }}><span className="text-yellow">[R]eview 1 orders (40 days old) &nbsp;</span></div></>, width: 100 },
    ]


    if (state.station.active) {
        station_columns = [
            { key: "station", align: "center", title: <>Station</>, width: 60 },
            { key: "name", align: "left", title: <>User</>, width: 251, grow: true },
            { key: "status", align: "left", title: <>Status</>, width: 200 },
            { key: "date", align: "left", title: <>AsOf</>, width: 100 },
        ]
    }



    const tool_columns = [
        {
            key: "tools", align: "left", title: <>Tools</>, width: 340, grow: true, render: (e, f) => {
                return (
                    <div className={(f.disabled) ? "beta" : ""}>
                        <Space size={6}>
                            <div></div>
                            <div style={{ "width": "35px", "textAlign": "center" }}>{f.key.label}</div>
                            <div></div>
                            <Divider vertical />
                            <div></div>
                            <div>{e}</div>
                        </Space>
                    </div>
                )
            }
        },
    ]


    const next = (_rows = 1, _data, _obj) => {
        if (_data.length === 0) { setState({ ...state, [_obj.key]: { ...state[_obj.key], "selected": {} } }); return; }
        const currentIndex = _data.findIndex(item => item[_obj.key] === _obj?.selected[_obj.key]);
        const nextIndex = Math.min(currentIndex + _rows, _data.length - 1);
        setState({ ...state, [_obj.key]: { ...state[_obj.key], "selected": _data[nextIndex] } });
    };

    const prev = (_rows = 1, _data, _obj) => {
        if (_data.length === 0) { setState({ ...state, [_obj.key]: { ...state[_obj.key], "selected": {} } }); return; }
        const currentIndex = _data.findIndex(item => item[_obj.key] === _obj?.selected[_obj.key]);
        const nextIndex = Math.max(currentIndex - _rows, 0);
        setState({ ...state, [_obj.key]: { ...state[_obj.key], "selected": _data[nextIndex] } });
    };


    const filterStations = () => {

        return stations.filter(item => {
            if (state.station.active) {
                return true;
            } else {
                return !item.status
            }
        })
    }





    return (
        <div style={{ height: "calc(100vh - 94px)", minHeight: "600px", }} className="controller">
            <div className="shim" /><div className="shim" />
            <div style={{ "padding": "0px 15px" }}>



                <Space grow size={10}>
                    <div className={(state.menu.active) ? "" : "desaturate"} style={{ flex: 1, display: 'flex', flexDirection: 'column', maxWidth: 300 }} onClick={() => setView("menu")}>
                        <VirtualTable
                            controller={controller}
                            header={<div style={{ "fontSize": "14px" }}>Main Menu</div>}
                            showColumnHeaders={false}
                            row_key={"menu"}
                            next={(_rows) => next(_rows, menu, state.menu)}
                            prev={(_rows) => prev(_rows, menu, state.menu)}
                            route={ROUTES.HOME.MENU}
                            current={(state.menu.active) ? state.menu.selected : {}}
                            data={menu}
                            width={0}
                            height={540}
                            offset={150}
                            onRowDoubleClick={(e) => {
                                if (e?.disabled) return;
                                kbdEvent(e.key)
                            }}
                            columns={menu_columns}
                            onRowClick={(item, event, index) => {
                                setTimeout(() => {
                                    setState({ ...state, ["menu"]: { ...state["menu"], "selected": item } });
                                }, 10)
                            }}
                        />
                    </div>

                    <div onClick={() => setView("station")} className={(state.station.active) ? "" : "desaturate"} style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 300 }}>
                        <HomeStations controller={controller} state={state} setState={setState} />
                    </div>

                    <div onClick={() => setView("notes")} className={(state.notes.active) ? "" : "desaturate"} style={{ flex: 1, display: 'flex', "pointerEvents" : (state.notes.active) ? "" : "none", flexDirection: 'column', minWidth: 300 }}>
                        <ReleaseNotes route={ROUTES.HOME.NOTES} controller={controller} />
                    </div>

                    <div className={(state.tools.active) ? "" : "desaturate"} style={{ flex: 1, display: 'flex', flexDirection: 'column', maxWidth: 300 }} onClick={() => setView("tools")}>
                        <VirtualTable
                            controller={controller}
                            header={<div style={{ "fontSize": "14px" }}>Tools</div>}
                            showColumnHeaders={false}
                            row_key={"tools"}
                            next={(_rows) => next(_rows, tools, state.tools)}
                            prev={(_rows) => prev(_rows, tools, state.tools)}

                            onRowClick={(e) => {

                                if (!state?.tools?.active) {
                                    setView("tools")
                                    return;
                                }
                                if (e?.disabled) return;
                                kbdEvent(e.key)
                            }}
                            route={ROUTES.HOME.TOOLS}
                            current={(state.tools.active) ? state.tools.selected : {}}
                            data={tools}
                            width={0}
                            height={540}
                            offset={150}
                            columns={tool_columns}
                        />

                    </div>

                </Space>
            </div>
            <div className="shim" />
            <Divider />
            <div style={{ 'height': "30px" }}>
                {(state.station.active &&
                    <Space style={{ "padding": "0px 15px" }}>
                        <Nav nav={station_nav} />
                    </Space>
                )}
            </div>


        </div>
    )
}


